<ng-template>
  <task-status [formControl]="formControl" [readonly]="readonly" [archived]="archived" [externalSystem]="externalSystem" [uiId]="controlId"></task-status>
</ng-template>
